import sample_1 from './sample1.jpeg';

export const dynamicIndustryImageImpressions = {
    sample_1,
};
